import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

// ACCOUNTS peer-workspace navigation. Internally role-gated: renders nothing for non-ACCOUNTS
// (so SUPER_ADMIN on /concierge keeps its own AdminNav and never sees this). Mirrors AdminNav's
// repo-native active-route + btn-primary/btn-ghost + horizontal-overflow mobile pattern.
const DESTINATIONS = [
  { to: "/accounts", label: "Assigned Shipments", testid: "accounts-nav-shipments-link" },
  { to: "/accounts/concierge", label: "Concierge", testid: "accounts-nav-concierge-link" },
];

export default function AccountsNav({ className = "" }) {
  const { profile } = useAuth();
  const { pathname } = useLocation();
  if (!profile || profile.role !== "ACCOUNTS") return null;
  return (
    <div
      className={`flex items-center gap-3 min-w-0 overflow-x-auto whitespace-nowrap [&>*]:shrink-0 lg:overflow-visible lg:whitespace-normal ${className}`}
      data-testid="accounts-nav"
    >
      {DESTINATIONS.map((d) => {
        const active = pathname === d.to || pathname.startsWith(d.to + "/");
        return (
          <Link key={d.to} to={d.to} className={active ? "btn-primary" : "btn-ghost"}
                data-testid={d.testid} aria-current={active ? "page" : undefined}>
            {d.label}
          </Link>
        );
      })}
    </div>
  );
}
